import { useEffect, useRef } from 'react'
import { useApp } from '../../context/AppContext'
import authServices from '../../services/AuthServices'

export default function SessionInit() {
    const { setCategories, setAmenities } = useApp()
    const hasInitialized = useRef(false)

    useEffect(() => {
        if (typeof window === 'undefined' || hasInitialized.current) return
        
        hasInitialized.current = true

        const initData = async () => {
            try {
                const [categoriesRes, amenitiesRes] = await Promise.all([
                    authServices.getCategories(),
                    authServices.getAmenities()
                ])

                setCategories(categoriesRes?.data || [])
                setAmenities(amenitiesRes?.data || [])
            } catch (err) {
                console.error('Failed to fetch init data:', err)
            }
        }

        initData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null
}